export default (state, value) => {
	console.info('🦑 SET_HAS_ETHEREUM_PROVIDER', value);
	state.hasEthereumProvider = value;
};
